try {
  const widgetId = document
    .getElementById("aisensy-wa-widget")
    ?.getAttribute("widget-id");

  if (!widgetId) {
    throw new Error("WA Widget is invalid or missing");
  }

//   console.log("Initializing AiSensy Widget...");

  // ---- Fetch widget details ---- //
  let aisensyLink = null;
  let aisensyWidgetOptions = null;

  const xhr = new XMLHttpRequest();
  xhr.open("GET", "https://wa.aisensy.com/widget-details/" + widgetId, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send();

  xhr.onload = function () {
    if (this.status === 200) {
      const data = JSON.parse(this.responseText);
    //   console.log("Widget details:", data);

      if (data.link) {
        aisensyLink = data.link;
      }

      if (!aisensyLink) {
        throw new Error("Invalid AiSensy widget details");
      }

      const btn = aisensyLink.whatsappBtnSettings;
      aisensyWidgetOptions = {
        linkid: aisensyLink.linkId,
        phoneNumber: aisensyLink.phoneNumber,
        variant: btn.variant,
        btnBackground: btn.btnBackground,
        btnCTA: btn.btnCTA,
        mb: btn.mb,
        ml: btn.ml,
        mr: btn.mr,
        borderRadius: btn.borderRadius,
        prefilledMsg: aisensyLink.prefilledMsg,
        position: btn.position,
        brandName: btn.brandName,
        brandSub: btn.brandSub,
        brandColor: btn.brandColor,
        brandImgUrl: btn.brandImgUrl,
        widgetBtnCTA: btn.widgetBtnCTA,
        openWidgetByDefault: btn.openWidgetByDefault,
        openWidgetSessionWindow: btn.openWidgetSessionWindow,
        onscreenMsg: btn.onscreenMsg,
        onscreenImg: "",
        widgetOnMobile: btn.widgetOnMobile,
        personalizedUrls: btn.personalizedUrls,
      };

      // Wait until widget-plugin.js is loaded
      if (typeof window.CreateWhatsAppButtonAndWidget === "function") {
        initWidget();
      } else {
        // Fallback: poll until available
        const check = setInterval(() => {
          if (typeof window.CreateWhatsAppButtonAndWidget === "function") {
            clearInterval(check);
            initWidget();
          }
        }, 200);
      }
    } else {
      console.error(`Error ${xhr.status}: ${xhr.statusText}`);
    }
  };

  function initWidget() {
    // console.log("Initializing widget with options:", aisensyWidgetOptions);
    if (aisensyWidgetOptions) {
      window.CreateWhatsAppButtonAndWidget(aisensyWidgetOptions);

      // ---- Apply Oswald font only to AiSensy widget ---- //
      const applyFont = () => {
        const widget = document.querySelector(".aisensy-whatsapp-widget");
        if (widget) {
          widget.style.fontFamily = "'Oswald', sans-serif";
          widget.querySelectorAll("*").forEach((el) => {
            el.style.fontFamily = "'Oswald', sans-serif";
          });
        }
      };

      // Run once and observe future DOM changes
      applyFont();
      const observer = new MutationObserver(() => applyFont());
      observer.observe(document.body, { childList: true, subtree: true });

      // ---- Handle URL changes (SPA navigation in Shopify) ---- //
      history.pushState = ((f) =>
        function pushState() {
          const ret = f.apply(this, arguments);
          window.dispatchEvent(new Event("pushstate"));
          window.dispatchEvent(new Event("locationchange"));
          return ret;
        })(history.pushState);

      history.replaceState = ((f) =>
        function replaceState() {
          const ret = f.apply(this, arguments);
          window.dispatchEvent(new Event("replacestate"));
          window.dispatchEvent(new Event("locationchange"));
          return ret;
        })(history.replaceState);

      window.addEventListener("popstate", () => {
        window.dispatchEvent(new Event("locationchange"));
      });

      // Re-init widget on URL change
      window.addEventListener("locationchange", () => {
        // console.log("URL changed, reloading AiSensy widget...");
        window.CreateWhatsAppButtonAndWidget({ ...aisensyWidgetOptions });
        applyFont();
      });
    }
  }
} catch (err) {
  console.error("WA widget error:", err);
}
